import {
  DEFAULT_ANNOTATION_STROKE_WIDTH,
  LEGACY_ANNOTATION_COLOR,
} from 'components/ImageViewer/constants';

/**
 * Annotorious passes a WebAnnotation wrapper to formatters on render, but
 * callers may also pass the raw W3C JSON. Normalize to the raw data object.
 */
const getAnnotationData = (annotation) =>
  (annotation && annotation.underlying) || annotation || {};

/**
 * Annotations can carry their style as top-level keys in their W3C JSON
 * (`data.style = { color, strokeWidth }`). Older annotations predate this, so
 * they fall back to their previous look (black stroke).
 */
export const getAnnotationStyle = (annotation) => {
  const style = getAnnotationData(annotation).style || {};

  return {
    color: style.color || LEGACY_ANNOTATION_COLOR,
    strokeWidth: style.strokeWidth || DEFAULT_ANNOTATION_STROKE_WIDTH,
  };
};

/**
 * Applies the annotation's stored color/stroke width to the shape Annotorious
 * renders. The geometry of ellipse and pencil annotations is swapped for the
 * real shape separately (see shapeRenderer) — Annotorious formatter elements
 * are drawn in screen space, so they cannot carry annotation geometry.
 */
export const annotationFormatter = (annotation) => {
  const { color, strokeWidth } = getAnnotationStyle(annotation);

  return {
    className: 'hw-annotation',
    style: [
      `stroke:${color}`,
      `stroke-width:${strokeWidth}`,
      `fill:${color}`,
      'fill-opacity:0.12',
    ].join(';'),
  };
};
